export default "__VITE_ASSET__mPKVokN0__"